import React from "react";
import { useNavigate } from "react-router-dom";
import { cn } from "../../Utils/helper";

const FooterContact = ({ className }) => {
  const navigate = useNavigate();

  return (
    <div
      className={cn(
        "absolute py-4 bottom-0 left-0 right-0 px-8 flex justify-between text-xs text-mid-gray bg-transparent", 
        className
      )}
    >
      <p>Copyright © 2025 Rally</p>
      <p>
        Any issues?{" "}
        <span
          className="underline cursor-pointer hover:text-[#253FF6] transition-colors"
          onClick={() => navigate("/profile/support/contactUS")}
        >
          Contact us
        </span>
      </p>
    </div>
  );
};

export default FooterContact;